import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useObservable } from "micro-observables";

import { openUserAction } from "../../../../../../../../services/UserActionConfirm/actions";
import {
    activeDataSelector,
    currentBlockSelector,
    setActiveDataSelector,
    setCurrentBlockSelector, setNewDataSelector,
    setUrlList
} from "../../../../services/stepThree";
import { setNormalizersByUrls } from "../../../../../../services/links/actions";
import { NORMALIZERS } from "../../../../../../constants";

const useSelectorListActions = ({ onLinksNameClose }) => {
    const dispatch = useDispatch();
    const dataSelector = useObservable(activeDataSelector);
    const blockSelector = useObservable(currentBlockSelector);

    const handleSaveLinksDone = useCallback(
        (formData) => {
            const { isRequired, prependDomainNameNormalizer, removeGetParametersNormalizer } = formData;
            const newDataSelector = { ...dataSelector };

            newDataSelector.name = `${formData.name === "other" ? formData.alternativeName : formData.name}`;
            newDataSelector.is_required = isRequired;
            newDataSelector.normalizers = NORMALIZERS.filter(({ code }) =>
                (prependDomainNameNormalizer && code === "normalizer.prepend-domain-name-normalizer") ||
                (removeGetParametersNormalizer && code === "normalizer.remove-get-parameters-normalizer")
            );

            const newBlockSelector = { ...blockSelector };
            newBlockSelector.data_selectors = [ ...newBlockSelector.data_selectors, newDataSelector ];

            setActiveDataSelector(null);
            setNewDataSelector(null);
            setUrlList([]);
            setCurrentBlockSelector(newBlockSelector);

            onLinksNameClose();
            dispatch(setNormalizersByUrls());
        },
        [ dataSelector, blockSelector, onLinksNameClose, dispatch ]
    );

    const handleDelete = useCallback(
        () => {
            setNewDataSelector(null);
            setUrlList([]);
        },
        []
    );

    const handleDeleteDataSelector = useCallback(
        () => {
            if(dataSelector?.selectors) {
                dispatch(openUserAction({
                    actionType: "remove Actions",
                    message: `Links - ${dataSelector.selectors.map(({ selector }) => selector).join("/@href, ")}`,
                    action: () => handleDelete()
                }));
            }
        },
        [ dataSelector, dispatch, handleDelete ]
    );

    return {
        handleDeleteDataSelector,
        handleSaveLinksDone
    };
};

export default useSelectorListActions;
